import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles({ name: "WorkspaceSelector" })((theme: Theme) => ({
    // theme.palette.text.secondary is deliberate over emteria.text.secondary: the emteria token is
    // the same white as its primary counterpart in dark mode, so secondary copy written with it
    // stops reading as secondary there.
    description: {
        minWidth: 0,
        color: theme.palette.text.secondary,
    },
    root: {
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: theme.spacing(2),
        marginTop: theme.spacing(1),
    },
    selectorGroup: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: theme.spacing(2),
    },
    workspaceSelectorAboveOverlay: {
        position: "relative",
        zIndex: 101,
    },
    selectWrap: {
        width: 360,
        maxWidth: "100%",
        minWidth: 0,
        "& .MuiFormControl-root": {
            margin: 0,
            width: "100%",
        },
        [theme.breakpoints.down("md")]: {
            width: "100%",
            flex: "1 1 100%",
        },
    },
    checkboxWrap: {
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
    },
}));
